import React from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AuthSplitLayout from "../components/auth/AuthSplitLayout";
import AuthCredentialsForm from "../components/auth/AuthCredentialsForm";
import { getAuthRedirectPath } from "../components/auth/authHelpers";
import SeoHead from "../components/SeoHead";
import { getPublicSeo } from "../utils/seoCatalog";

const LoginPage = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectPath = getAuthRedirectPath(searchParams);

  if (isAuthenticated && !loading) {
    return <Navigate to={redirectPath} replace />;
  }

  const handleSuccess = () => {
    navigate(redirectPath, { replace: true });
  };

  return (
    <>
      <SeoHead {...getPublicSeo("login")} />

      <AuthSplitLayout mode="login" searchParams={searchParams}>
        <AuthCredentialsForm
          mode="login"
          searchParams={searchParams}
          onSuccess={handleSuccess}
        />
      </AuthSplitLayout>
    </>
  );
};

export default LoginPage;
